var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-sidebar" }, [
    _c(
      "div",
      {
        ref: "header",
        staticClass: "booking-header-extension",
        attrs: { "data-component": "booking-fans-flyout-header" },
      },
      [
        _c(
          "div",
          {
            staticClass: "booking-header-close",
            class: [{ "show-both": _vm.backArrow }],
            attrs: { "data-component": "booking-header-close" },
          },
          [
            _c("span", {
              staticClass: "icon-arrow-back",
              attrs: { "aria-label": _vm.tc("booking.back"), tabindex: "0" },
              on: {
                click: _vm.getBack,
                keypress: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.getBack($event)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.getBack($event)
                  },
                ],
              },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "icon-close",
              attrs: { "aria-label": _vm.tc("booking.close"), tabindex: "0" },
              on: {
                click: _vm.closeModal,
                keypress: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.closeModal($event)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.closeModal($event)
                  },
                ],
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "booking-header-extension-wrapper container" },
          [
            _c("div", { staticClass: "booking-header-extension-left" }, [
              _c(
                "div",
                { staticClass: "title", attrs: { id: "cart-overview-title" } },
                [_vm._v(_vm._s(_vm.tc("auth.sidebarTitle")))]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "auth-sidebar-scroll",
        style: [{ height: _vm.scrollHeight + "px" }],
        attrs: { "data-component": "booking-fans-flyout-body" },
      },
      [
        _c(
          "transition",
          { attrs: { name: "fade" } },
          [
            _c(_vm.componentName, {
              tag: "component",
              on: {
                "change-component": function ($event) {
                  _vm.currentComponent = $event
                },
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }